import React, { FC, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import './container.css'

// COMPONENTS
import { ColumnHeader } from '../header'
import { ColumnFooter } from '../footer'
import { Toaster } from '../../../shadcn/sonner'

// UTILITIES
import { ColumnContext } from '../_localStore/reducer'
import { useColumnReducer } from '../_localStore/_hooks'
import { flatten } from '@utils/string-helper'
import { injectVars } from '@utils/temp-helpers'


interface Props extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode
    noShadow?: boolean
    noLogo?: boolean
}

const ColumnContainer: FC<Props> = (props) => {
    const { className: classProps, style: styleProps, children, noShadow, noLogo, ...divProps } = props
    const reducer = useColumnReducer()
    const { transitionTime } = reducer.localState
    const location = useLocation()
    const mainKey = (location.pathname === '/account' && !!location.search) ? location.search as React.Key : undefined

    const ccBoundingBox = flatten("column-bounding-box", { noShadow }, classProps)
    const style = injectVars({ "--animation-time": `${(transitionTime / 1000) || 0.1}s` }, styleProps)

    const useWhiteBackground = useMemo(() => {
        const pathName = window.location.pathname
        return !['sign-in', 'verify'].includes(pathName.replace('/', ''))
    }, [window.location.pathname])

    return (
        <ColumnContext.Provider value={reducer}>
            <div
                className={ccBoundingBox}
                style={{ ...style, background: useWhiteBackground ? undefined : 'var(--splitcard-blue-500)' }}
                {...divProps}
            >
                <ColumnHeader.Outlet content={noLogo ? 'empty' : 'logo'} />
                <main key={mainKey}>{children}</main>
                <Toaster richColors position="top-center" style={{ marginTop: 'var(--header-height)' }}/>
                <ColumnFooter.Outlet />
            </div>
        </ColumnContext.Provider>
    )
}

export { ColumnContainer }
